import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardLogList extends BaseModelAPI {

	static entity = 'controlcardloglist'
	static entityName = 'controlcardlog';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
